import { Flex, Text } from '@servicetitan/anvil2';
import { Calculation } from '@servicetitan/financing-api-client';
import { formatCurrency } from '@servicetitan/financing-utils-shared';
import { useProviderConfig } from '@servicetitan/financing-workflow-shared';

interface SuggestedPaymentProps {
    plan: Calculation;
    isStart?: boolean;
    eyebrowText?: string;
}

export const SuggestedPayment = ({
    plan,
    isStart = false,
    eyebrowText = '',
}: SuggestedPaymentProps) => {
    const { termMultiplier } = useProviderConfig();
    return (
        <Flex direction="column" gap="3">
            <Text variant="eyebrow" style={{ minHeight: '1rem' }}>
                {eyebrowText}
            </Text>
            <Flex direction="column" gap="half">
                <div>
                    <Text variant="body" size="large" inline style={{ lineHeight: 0.5 }}>
                        <strong style={{ lineHeight: 0.5 }}>
                            {formatCurrency(
                                isStart
                                    ? plan.defaultMonthlyPayment!
                                    : plan.suggestedMonthlyPayment!,
                            )}
                        </strong>
                    </Text>
                    <Text variant="body" inline>
                        /mo.
                    </Text>
                </div>
                <Text variant="body" size="small">
                    {'for '}
                    <strong>
                        {isStart ? plan.defaultTerms * termMultiplier : (plan.suggestedTerms ?? 0)}{' '}
                        months
                    </strong>
                </Text>
            </Flex>
        </Flex>
    );
};
